exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.group-title-wrapper[data-v-bc4c9e36] {\n    width: 100%;\n}\nh1[data-v-bc4c9e36] {\n    font-size: 22px;\n}\nh1.edit-d-title[data-v-bc4c9e36]::after {\n    background: transparent;\n    right: -40px;\n    color: #cbd3cb;\n}\ntextarea.title-field[data-v-bc4c9e36] {\n    font-size: 2.25rem;\n}\n", ""]);

// exports
